import React, { useState, memo } from 'react';
import { Link } from 'gatsby';
import {injectIntl} from "gatsby-plugin-intl";
import './how-it-works.scss';
import { useInView } from 'react-intersection-observer';

const HowItWork = ({intl: { formatMessage, locale } }) => {
  const [currentInView, setCurrentInView] = useState(false);
  const [ref, inView] = useInView({
    threshold: 0,
  });
  if (inView && !currentInView) {
    setCurrentInView(true);
  }

  const currentLocale = locale === 'en' ? '': `/${locale}`
  return (
    <div className="how-it-works-section" ref={ref}>
      <div className="page-content">
        <h2 id="how-it-works">  {formatMessage({id: 'How it works'})}</h2>
        <iframe
          src={currentInView ? 'https://www.youtube.com/embed/R1Bz4y3O4j4?rel=0&amp;controls=0&amp;showinfo=0?ecver=2' : null}
          width="640"
          height="360"
          frameBorder="0"
          webkitallowfullscreen=""
          mozallowfullscreen=""
          allowFullScreen=""
        />
        <ol>
          <li>
            <h3 id="bet-on-the-worlds-biggest-jackpots">
              {formatMessage({id: 'HIWH1'})}
            </h3>
            {formatMessage({id: 'HIWP1'})}
          </li>
          <li>
            <h3 id="in-the-same-way-as-your-favorite-lottery">
              {formatMessage({id: 'HIWH2'})}
            </h3>
            {formatMessage({id: 'HIWP2'})}
          </li>
          <li>
            <h3 id="opening-up-the-world-for-you">
              {formatMessage({id: 'HIWH3'})}
            </h3>
            {formatMessage({id: 'HIWP3'})}
          </li>
          <li>
            <h3 id="we-have-the-freedom-to-offer-you-more-">
              {formatMessage({id: 'HIWH4'})}
            </h3>
            {formatMessage({id: 'HIWP4'})}
          </li>
        </ol>
        <h2 id="how-can-lotteroo-pay-such-high-jackpot-amounts-">
          {formatMessage({id: 'HIWH5'})}
        </h2>
        <p>
          {formatMessage({id: 'HIWP5'})}
        </p>
      </div>
      <div className="link-wrap">
        <Link to={`${currentLocale}/security`}>
          {formatMessage({id: 'Visit Our Security Page'})}
        </Link>
      </div>
    </div>
  );
};

export default memo(injectIntl(HowItWork));
